<template>
  <div class="base">
    <div class="base_x">
      <div class="base_box">
        <div
          class="base_box_item"
          @click="navigation(item.id)"
          v-for="(item, index) in form"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="base_box_records">
      <div style="text-align: center;">
      <div class="base_box_records1">妍诗美社(海南)医美健康科技有限公司</div>

 <div class="base_box_records1">
        © {{ this.year }} YSTE (Hainan) Aesthetic Medicine Health Technology Co., Ltd All Rights Reserved
      </div>
      </div>
     <div style="text-align: center; padding-top: 10px;">
       <div class="base_box_records1">
        <a class="ForReference" target="_blank" href="https://beian.miit.gov.cn"
          >琼ICP备2022001070号-1</a
        >
      </div>
      <div class="base_box_records1">
        <img
          style="
            width: 18px;
            height: 18px;
            vertical-align: bottom;
            margin-left: 10px;
          "
          src="../../../assets/img/pc/badge.png"
          alt=""
        />
        <a
          class="ForReference"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46020502000028"
          >琼公网安备 46020502000028号</a
        >
      </div>
     </div>
     
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: [
        {
          name: "ABOUT US",
          id:4
        },
        {
          name: "PRODUCT CONCEPT",
          id:5
        },
        {
          name: "CONTACT US",
          id:8
        },
        {
          name: "BRAND CONCEPT",
          id:7
        },
        {
          name: "CASE CENTENT",
          id:6
        },
      ],
      year:'2024'
    };
  },
  mounted() {
    const now = new Date();
this.year = now.getFullYear();
  },
  methods: {
    navigation(e) {
      this.$store.commit("app/loginShow", e);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/pc/base.css";
.base {
  border-top: 1px solid #e0e0e0;
  min-width: 1200px;
}
.base_x {
  border-bottom: 1px solid #e0e0e0;
}
.base_box {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pc/base/index.vue